<template>
  <div class="lottery-wrap" ref="container">
    <div class="roll_box" v-if="items">
      <grid-roll
        ref="dial"
        @underway="handleUnderway"
        class="box"
        direction="r"
        interval="3px"
        :startIndex="startIndex"
        :circle="circle"
      >
        <template #button>
          <grid-start>
            <div @click="handleStart" class="start-btn"></div>
          </grid-start>
        </template>
        <template #prize>
          <grid-prize
            v-for="(item, index) in items"
            :key="index"
            :pid="item.id"
            :selStyle="{'box-shadow': '#fff 0 0 12px 4px'}"
          >
            <div class="prize-img">
              <img :src="item.sm_image" />
            </div>
          </grid-prize>
        </template>
      </grid-roll>
    </div>
    <div class="dialogs" v-if="visibleResult">
      <div class="dialog">
        <img :src="result.image || require('@/assets/img/lottery/谢谢参与icon.png')" class="img" alt="">
        <div class="content"><div v-html="result.message"></div></div>
        <div class="btn-wrap">
          <button class="invite-btn" v-log="'lottery_to_share'" @click="$parent.visibleShare = true"></button>
          <button class="replay-btn" v-log="'lottery_to_index'" @click="$router.push({name: 'index', replace: true })"></button>
        </div>
        <div class="close" @click="visibleResult = false"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { Dialog } from 'vant'
import { gridRoll, gridStart, gridPrize } from 'grid-roll'
import 'grid-roll/dist/grid-roll.min.css'

export default {
  name: 'lottery',
  components: {
    [gridRoll.name]: gridRoll,
    [gridStart.name]: gridStart,
    [gridPrize.name]: gridPrize
  },
  data() {
    return {
      startIndex: 1,
      circle: 10,
      items: null,
      visibleResult: false,
      result: {
        message: '很遗憾，奖品从您手中溜走啦~<p><span>邀请好友参与寻找孩子王，</span></p><p><span>排名top10还有惊喜礼品哦！</span></p>'
      }
    }
  },
  methods: {
    async getAward () {
      try {
        const res = await this.$fetch.get('/looking-for-friend/prize-list/')
        console.log(res.data.data)
        this.items = res.data.data
        // this.items.splice(0, 1)
        if (this.items.length < 9) {
          const noPrizeItem = []
          for (let i = 1; i < 9 - this.items.length; i++) {
            noPrizeItem.push({ id: 0, sm_image: require('@/assets/img/lottery/谢谢参与.png') })
          }
          console.log(noPrizeItem)
          this.items = this.randomInsert(this.items, noPrizeItem)
        }
        this.$toast.clear()
      } catch (error) {
        console.log('error', error)
        this.$toast('获取奖品失败')
      }
    },
    randomInsert(arr1, arr2) {
      arr1.forEach(value =>
        arr2.splice(Math.random() * arr2.length, 0, value))
      return arr2
    },
    checkTimeStatus(time) {
      if (!time) {
        return 0
      }
      const date = +new Date(time.replace(/-/g, '/'))
      const now = +new Date()
      return +(date > now)
    },
    checkActivityTime() {
      if (this.checkTimeStatus(this.activity.start_time)) {
        return 1
      }
      if (!this.checkTimeStatus(this.activity.end_time)) {
        return 2
      }
      return 0
    },
    init(check = true) {
      const status = this.checkActivityTime()
      const act = ['未开始', '已结束']
      if (status) {
        Dialog.alert({
          message: `活动${act[status - 1]}`
        })
        return
      }
      return true
    },
    async handleStart () {
      if (!this.activity.is_subscribe) {
        this.$parent.visibleQrcode = true
        return
      }
      if (!this.init()) {
        return
      }
      this.$refs.dial.continueRoll()
      let b
      try {
        const { data } = await this.$fetch.post('/lottery/lottery', { able_type: this.activity.package_name })
        if (data.status === 0) {
          b = await this.$refs.dial.startRoll(0)
        } else {
          b = await this.$refs.dial.startRoll(data.id)
        }
        if (b) {
          // alert('恭喜你抽了个奖')
          const timer = setTimeout(() => {
            console.log(data)
            let tips = `<p>恭喜您，抽中${data.message}</p>`
            switch (data.type) {
              case 1:
                // 实物
                tips += '<p><span>请前往活动首页“我的奖品”</span></p>输入收货信息，才可以确保能收到礼品哦！'
                break
              case 2:
                // 虚拟
                tips += '<p><span>请前往活动首页“我的奖品”</span></p>填写手机号码，以便后续接收卡号和密码'
                break
              case 3:
                // 红包
                tips += '<p>已自动存入您的微信零钱</p>请留意微信消息通知!'
                break
              case 4:
                // 立减金
                tips += '<p>span>请前往活动首页“我的奖品”点击领取</span></p>'
                break
              default:
                tips = '很遗憾，奖品从您手中溜走啦~<p><span>邀请好友参与寻找孩子王，</span></p><p><span>排名top10还有惊喜礼品哦！</span></p>'
                break
            }
            data.message = tips
            this.visibleResult = true
            this.result = data
            console.log(tips)
            clearTimeout(timer)
          }, 400)
        }
      } catch (error) {
        console.log('error', error)
        b = await this.$refs.dial.startRoll(0)
        this.$toast(error.response.data.message)
      }
    },
    handleUnderway (index) {
      // console.log('进行中,index=' + index)
    }
  },
  created() {
    this.getAward()
  },
  mounted() {
    this.$parent.setDevice(this.$refs.container)
  }
}
</script>

<style lang='scss' scoped>
.lottery-wrap {
  background: url(~@/assets/img/lottery/抽奖bg.png) no-repeat;
  background-size: auto 100%;
  background-position: center 0;
  display: flex;
  align-items: center;
  justify-content: center;
  .roll_box {
    background: url(~@/assets/img/lottery/抽奖框.png) no-repeat;
    background-size: 100%;
    width: 772px;
    height: 563px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .dialogs {
    background: rgba(0, 0, 0, .6);
    z-index: 999;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    .close {
      position: absolute;
      background: url(~@/assets/img/关.png) no-repeat;
      background-size: 100%;
      width: 42px;
      height: 42px;
      right: 0;
      top: 30px;
    }
    .dialog {
      background: url(~@/assets/img/lottery/弹窗bg.png) no-repeat;
      background-size: 100%;
      width: 768px;
      height: 695px;
      position: relative;
      .img {
        // width: auto;
        max-width: 134px;
        max-height: 163px;
        position: absolute;
        top: 292px;
        left: 50%;
        display: block;
        transform: translateX(-50%);
      }
      .content {
        position: absolute;
        font-size: 26px;
        color: #472B1C;
        width: 500px;
        height: 120px;
        display: flex;
        align-items: center;
        justify-content: center;
        top: 480px;
        left: 50%;
        transform: translateX(-50%);
        ::v-deep span {
          font-weight: bold;
          color: #E30300;
        }
      }
      .btn-wrap {
        display: flex;
        justify-content: space-around;
        width: 400px;
        position: absolute;
        bottom: 28px;
        left: 50%;
        transform: translateX(-50%);
        button {
          border: none;
          width: 163px;
          height: 61px;
        }
        .invite-btn {
          background: url(~@/assets/img/邀好友玩.png) no-repeat;
          background-size: 100%;
        }
        .replay-btn {
          background: url(~@/assets/img/再玩一次.png) no-repeat;
          background-size: 100%;
        }
        .lottery-btn {
          background: url(~@/assets/img/去抽奖按钮.png) no-repeat;
          background-size: 100%;
        }
      }
    }
  }
  .start-btn {
    width: 153px;
    height: 153px;
    background: url('../../assets/img/lottery/开始.png') no-repeat;
    background-size: contain;
  }
  .prize-img {
    width: 153px;
    height: 153px;
    img{
      width: 100%;
      height: 100%;
    }

  }
}
</style>
